const setSubscriptionsInfo = (data) => ({
  type: "SET_SUBSCRIPTIONS_INFO",
  data,
});

export const mutation = {
  setSubscriptionsInfo,
};
